import config from "@/config/env.config.json";
const envConfig = config[process.env.NODE_ENV];
export default {
  ENVS: {
    PROD: "production",
    DEV: "dev",
    TEST: "test",
  },
  DEFAULT_TAB_TITLE: "100Plus Patient Portal",
  LOGIN_FORM: {
    VERIFICATION_FAILED_TEXT: (loginMode) =>
      `${
        loginMode === "SMS" ? "Phone Number" : "Email"
      } and Date of Birth do not match.${
        loginMode === "SMS"
          ? " Please try again, or login using your email address."
          : " Please try again, or login using your phone number"
      }`,
    OTP_VERIFY_FAILED_TEXT: "The code entered is incorrect, please try again.",
    API_ERROR_TEXT: (errorCode) => {
      const ERROR_CODES = {
        sms_provider_error: `To login, we need to send you a security code, but your phone has previously unsubscribed from our number. Please text “START” to ${envConfig.auth02faPhoneNumber}`,
      };
      return errorCode in ERROR_CODES
        ? ERROR_CODES[errorCode]
        : "There was an issue logging you in, please try again later.";
    },
    ACCEPT_TOS: "Please accept our Privacy Policy and Terms of Use.",
    LOGIN_OPTIONS: [
      { label: "Phone", value: "SMS" },
      { label: "Email", value: "EMAIL" },
    ],
    LOGIN_TYPE: {
      SMS: "SMS",
      EMAIL: "EMAIL",
    },
  },
  SHARE_READINGS_FORM: {
    HIPPAA_CONSENT_TEXT:
      "Individual is authorized to see patient's data (HIPPA)",
    API_ERROR_TEXT:
      "There was an issue sharing your data, please try again later.",
    RELATIONSHIP: "Relationship to patient",
    SPECIALTY: "Specialty",
    FAX_NUMBER: "Fax number (if applicable)",
    EMAIL_ADDRESS: "Email address",
    PHONE_NUMBER: "Phone number (optional)",
    PROVIDER_NAME: "Full name",
    FREQUENCY: "Frequency",
    SHARE: "Share",
  },
  DEVICE_TYPES: {
    SCALE: "SCALE",
    BP_CUFF: "BP_CUFF",
    GLUCOMETER: "GLUCOMETER",
    PULSE_OXIMETER: "PULSE_OXIMETER",
  },
  DEVICE_TYPE_TO_READING_NAME: {
    SCALE: "Weight",
    BP_CUFF: "Blood Pressure",
    GLUCOMETER: "Blood Glucose",
    PULSE_OXIMETER: "Blood Oxygen",
  },
  DEVICE_TYPE_TO_READINGS_API_PARAMS: {
    scale: "weight",
    bp_cuff: "bp",
    glucometer: "bg",
    pulse_oximeter: "po",
  },
  DEVICE_TYPE_UNITS: {
    SCALE: "lbs",
    BP_CUFF: "mmHg",
    GLUCOMETER: "mg/dL",
    PULSE_OXIMETER: "SpO2",
  },
  // DEVICE_TYPE_SAMPLE_READINGS: {
  //   scale: {
  //     readings: [
  //       {
  //         serial: "TYEFEGHRT456456",
  //         ts: "2022-10-25 11:54:55.083000+00:00",
  //         weight: "219.937154734118",
  //       },
  //       {
  //         serial: "TYEFEGHRT456456",
  //         ts: "2022-09-02 18:54:55.083000+00:00",
  //         weight: "221.937154734118",
  //       },
  //     ],
  //   },
  //   bp_cuff: {
  //     readings: [
  //       {
  //         diastolic: "217.51798000",
  //         pulse: "67",
  //         serial: "BPC4323425",
  //         systolic: "120.00992000",
  //         ts: "2020-05-20 00:33:53.983000+00:00",
  //       },
  //     ],
  //   },
  //   glucometer: {
  //     readings: [
  //       {
  //         before_meal: true,
  //         reading_mgdL: 88,
  //         reading_mmolL: 5,
  //         serial: "BGM34535",
  //         ts: "2022-09-07 18:05:48+00:00",
  //       },
  //       {
  //         before_meal: true,
  //         reading_mgdL: 84,
  //         reading_mmolL: 6,
  //         serial: "BGM34535",
  //         ts: "2022-09-03 18:05:48+00:00",
  //       },
  //     ],
  //   },
  //   pulse_oximeter: {
  //     readings: [
  //       {
  //         pulse_bpm: 87.0,
  //         serial: "FPO12333444",
  //         spo2: 65.0,
  //         ts: "2022-09-09 02:33:48+00:00",
  //       },
  //       {
  //         pulse_bpm: 76.0,
  //         serial: "FPO12333444",
  //         spo2: 89.0,
  //         ts: "2022-09-02 02:33:48+00:00",
  //       },
  //     ],
  //   },
  // },
  DAYS: {
    ZERO_DAYS_AGO: "in 0 days",
    ONE_DAY_AGO: "1 day ago",
  },
  DISCLAIMERS: {
    READINGS_DISCLAIMER:
      "Readings take a few minutes to upload, but can take longer in areas with poor cell service.",
    LEGAL_DISCLAIMER:
      "This is not an emergency monitoring service, if you have an urgent medical problem or condition, please call 9-1-1 immediately.",
  },
  WORD_GAME: {
    WORD_OF_THE_DAY: "Word of the Day",
  },
};
